import { useCallback, useEffect, useState } from "react"
import Cookies from "js-cookie"

// The cookie is the source of truth so we pick up writes from other tabs;
// `token` state mirrors it only to trigger UI rerenders. Request paths must
// call getToken() rather than read `token` to avoid stale closures.
export const useTokenCookie = (tokenName) => {
    const [token, setTokenState] = useState(Cookies.get(tokenName))

    const getToken = useCallback(() => Cookies.get(tokenName), [tokenName])

    const setToken = useCallback((_token, expires) => {
        Cookies.set(tokenName, _token, expires ? { expires: new Date(expires) } : {})
        setTokenState(_token)
    }, [tokenName])

    const clearToken = useCallback(() => {
        Cookies.remove(tokenName)
        setTokenState(undefined)
    }, [tokenName])

    const reconcileFromCookie = useCallback(() => {
        const fromCookie = Cookies.get(tokenName)
        setTokenState(prev => prev === fromCookie ? prev : fromCookie)
    }, [tokenName])

    useEffect(() => {
        const handler = () => {
            if (document.hidden) return
            reconcileFromCookie()
        }
        document.addEventListener('visibilitychange', handler)
        return () => document.removeEventListener('visibilitychange', handler)
    }, [reconcileFromCookie])

    return { token, getToken, setToken, clearToken, reconcileFromCookie }
}
